'use no memo';
import type {ReactElement} from 'react';
import React from 'react';
import {useSingleActivePosterItem} from '@Hooks/poster-editor/useSingleActivePosterItem';
import {BaseImageMediaControls} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-image-media-controls';
import type {ItemData} from '@PosterWhiteboard/page/add-item.class';
import {onReplaceMedia} from '@PosterWhiteboard/page/replace-item.class';
import type {ImageMediaControlsProps} from '@Components/poster-editor/components/poster-editing-side-panel/components/image-media-controls/image-media-controls.types';
import {useGetKeyFromImageItem} from '@Hooks/poster-editor/useGetKeyFromImageItem';
import {RemoveBackgroundStatus} from '@PosterWhiteboard/items/item/item.types';

export function ImageMediaControls(props: ImageMediaControlsProps): ReactElement | null {
  const activeItem = useSingleActivePosterItem();
  const removeBackground = useGetKeyFromImageItem('removeBackground');
  const removeBackgroundStatus = removeBackground?.isBackgroundBeingRemoved
    ? RemoveBackgroundStatus.REMOVING
    : removeBackground?.isBackgroundRemoved
      ? RemoveBackgroundStatus.REMOVED
      : RemoveBackgroundStatus.NONE;

  if (!activeItem) {
    throw new Error('Active item is null - unable to show image media controls');
  }

  if (!activeItem?.isImage()) {
    throw new Error(`Expected an image item, instead got ${activeItem.gitype}`);
  }

  const onReplaceImage = (itemToReplaceWith: ItemData): void => {
    onReplaceMedia(itemToReplaceWith);
  };

  return <BaseImageMediaControls activeItem={activeItem} removeBackgroundStatus={removeBackgroundStatus} onReplaceImage={onReplaceImage} onClickAiEdit={props.onClickAiEdit} />;
}
